import React, {Component} from 'react';
import Parameters from '../common/Parameters';
import Translation from '../common/Translation';
import BaseQuery from '../common/BaseQuery';
import AnketaParams from "./AnketaParams";
import Overlay from "./Overlay";
import Select from './inputs/Select';
import CircularProgress from "@mui/material/CircularProgress";
import './css/style.sass';

export default class Anketa extends Component {

    constructor() {
        super();
        const parameters = new Parameters();
        this.eventId = parameters.getEventId();
        this.lang = parameters.getLang();

        this.state = {
            messages: this.getMessages(),
            displayOverlay: false,
            overlayText: "",
            event_name: "",
            logo: "",
            anketa_bg_file: "",
            fields: [],
            is_registration_open: true,
            showQuickLogin: false,
            quickLoginEmail: "",
        };

        this.hideOverlay = this.hideOverlay.bind(this);
        this.onAlreadyRegisteredClick = this.onAlreadyRegisteredClick.bind(this);
        this.onQuickLoginSubmit = this.onQuickLoginSubmit.bind(this);
    }

    getMessages() {
        return {
            ["Регистрация учасников"]:"Реєстрація учасників",
            ["Я уже регистрировался"]:"Я уже регистрировался",
            ["Отправить"]:"Отправить",
            ["Реєстрація закрита"]:"Реєстрація закрита"
        };
    }

    getTitle() {
        return this.state.messages["Регистрация учасников"];
    }


    getAlreadyAnswered() {
        return this.state.messages["Я уже регистрировался"];
    }

    getFormType() {
        return "anketa";
    }

    getFormParameters() {
        AnketaParams.get(this.eventId, this.lang, (anketa) => {
            AnketaParams.paramNames().forEach((name) => {
                let state = this.state;
                state[name] = anketa.hasOwnProperty(name)
                    ? anketa[name]
                    : '';

                this.setState({
                    ...state
                });
            });

        }, (error) => {
            this.setState({error: error})
        });
    }

    getTranslation(message) {
        console.log("TRANS: "+message);
        if(typeof this.state.messages[message] === 'string') {
            return this.state.messages[message];
        }

        return message;
    }

    getFormFields() {
        if(this.state.fields.length === 0) {
            return null;
        }

        return this.state.fields.map((field, i)=>{
            let overlayText = field["overlay_text"];
            let inputClasses="registration-form__titles";
            if(!!overlayText) {
                inputClasses+=" registration-form__titles_link";
            }

            const required = !!field['is_required'];
            const label = field["label"] + (required ? " *" : "");
            const clickFn = () =>{ return !!overlayText ? this.showOverlay(overlayText) : false;};

            switch (field['type']) {
                case 'email':
                case 'text': {
                    return (
                        <React.Fragment key={i}>
                        <div className={inputClasses} onClick={clickFn}>
                        {label}
                        </div>
                        <input name={field['name']} required={required} placeholder={field['label']} type={field['type']}/>
                        </React.Fragment>
                    );
                }
                case 'checkbox': {
                    return (
                    <React.Fragment key={i}>
                        <div style={{display:"inline-block"}}>
                    <div className={inputClasses} style={{float:"left"}}
                        onClick={clickFn}
                    >
                        {label}
                    </div>
                        <input name={field['name']} required={required} type="checkbox"/>
                            </div>
                    </React.Fragment>
                    );
                }
                case 'hidden': {
                    return (
                        <React.Fragment key={i}>
                            <input type="hidden" name={field['name']} value={field['list_values']}/>
                        </React.Fragment>
                    )
                }
                case 'comment': {
                    return (
                        <React.Fragment key={i}>
                            <div style={{display:"inline-block"}} dangerouslySetInnerHTML={{ __html: overlayText }} />
                        </React.Fragment>
                    )
                }
                case 'select': {
                    return (
                        <React.Fragment key={i}>
                            <div style={{display:"inline-block"}}>
                            <div className={inputClasses} style={{float:"left"}}
                                 onClick={clickFn}
                            >
                                {label}
                            </div>
                            <Select field={field}/>
                            </div>
                        </React.Fragment>
                        );
                }
            }
        });
    }

    hideOverlay() {
        let state = this.state;
        state.displayOverlay=false;
        this.setState({...state});
    }

    showOverlay(text="") {
        const overlayText=!!text ? text : this.state.overlayText;
        if(!overlayText) {
            return;
        }

        let state = this.state;
        state.overlayText=overlayText;
        state.displayOverlay=true;

        this.setState({...state});
    }

    componentDidMount() {
        let phrases = [];
        for(let message in this.state.messages) {
            phrases.push(message);
        }

        Translation.translate(phrases, this.lang, (translation) => {
                // console.log("-----");
                // console.log(translation);
                // console.log("-----");

                const state=this.state;
                state.messages=translation;

                this.setState({...state});
            }, () => {
                // this.setDefaultMessage();
            },
            this.eventId
        );

        this.getFormParameters();

    }

    onSubmitClick() {
        // PostForm.save(fields,()=>{alert("Success");},()=>{alert("Error");})

        return true;
    }

    onAlreadyRegisteredClick(e) {
        e.preventDefault();
        this.setState({ showQuickLogin: true });
    }

    onQuickLoginSubmit() {
        const email = this.state.quickLoginEmail.trim();
        if (!email || !email.includes('@') || !email.includes('.')) return;
        window.location.href = BaseQuery.getOrigin() +
            '/index.php?p=remote&op=quickenter&event_id=' + this.eventId +
            '&member-email=' + encodeURIComponent(email);
    }


    getForm() {
        return (
            <form className="registration-form" action={BaseQuery.getOrigin()}>
                <input type="hidden" name="p" value={this.getFormType()}/>
                <input type="hidden" name="event_id" value={this.eventId}/>
                <input type="hidden" name="op" value="save"/>
                <input type="hidden" name="source" value="newanketa"/>

                {this.getFormFields()}

                {this.state.is_registration_open
                    ? <button className="button" onClick={this.onSubmitClick}>{this.state.messages["Отправить"]}</button>
                    : <div className="registration-closed-message">{this.state.messages["Реєстрація закрита"]}</div>
                }
                <button className="button button_right" onClick={this.onAlreadyRegisteredClick}>{this.getAlreadyAnswered()}</button>
            </form>
        );
    }

    render() {
        if(this.state.fields.length === 0) {
            return (<CircularProgress/>);
        }

        if (this.state.anketa_bg_file) {
            document.body.style.backgroundImage = `url(${this.state.anketa_bg_file})`;
            document.body.style.backgroundSize = 'cover';
            document.body.style.backgroundPosition = 'center';
            document.body.style.backgroundAttachment = 'fixed';
        } else {
            document.body.classList.add('registration-bg');
        }

        return (
            <div>
                <div className="registration">
                    <div className="anketa-form-div">
                        <img src={this.state.logo} alt={this.state.event_name}/>
                        <div className="registration__title">{this.getTitle()} {this.state.event_name}</div>
                        {this.getForm()}
                    </div>
                </div>

                <Overlay display={this.state.displayOverlay} text={this.state.overlayText} closeCb={this.hideOverlay}/>

                {this.state.showQuickLogin && (
                    <div className="overlay">
                        <div className="modal" style={{minHeight: 'auto'}}>
                            <div className="modal__close" onClick={() => this.setState({ showQuickLogin: false })}>&times;</div>
                            <div className="modal__subtitle">{this.state.messages["Я уже регистрировался"]}</div>
                            <div style={{marginTop: '20px'}}>
                                <input
                                    type="email"
                                    placeholder="E-mail"
                                    value={this.state.quickLoginEmail}
                                    onChange={(e) => this.setState({ quickLoginEmail: e.target.value })}
                                    onKeyDown={(e) => { if (e.key === 'Enter') this.onQuickLoginSubmit(); }}
                                    style={{width: '100%', padding: '10px', fontSize: '16px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box'}}
                                    autoFocus
                                />
                                <button
                                    className="button"
                                    onClick={() => this.onQuickLoginSubmit()}
                                    style={{width: '100%', marginTop: '10px'}}
                                >
                                    {this.state.messages["Отправить"]}
                                </button>
                            </div>
                            <noscript>
                                <a href={"/index.html?p=quicklogin&event_id=" + this.eventId}>Перейти до входу</a>
                            </noscript>
                        </div>
                    </div>
                )}

            </div>
        );
    }
}
